import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { api, errMsg, toKSTInput, fromKSTInput, fmtKST } from "@/lib/api";

export default function HigherPayByDialog({ onClose }) {
  const [value, setValue] = useState("");
  const [current, setCurrent] = useState("");
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    api.get("/higher/settings").then((r) => { setCurrent(r.data.pay_by); setValue(toKSTInput(r.data.pay_by)); }).catch(() => {});
  }, []);

  const save = async (pay_by) => {
    setBusy(true);
    try {
      await api.put("/higher/settings", { pay_by });
      toast.success(pay_by ? `Higher EMS pay-by set to ${fmtKST(pay_by)}` : "Higher EMS pay-by date cleared");
      onClose();
    } catch (err) {
      toast.error(errMsg(err, "Couldn't save the pay-by date"));
    } finally {
      setBusy(false);
    }
  };

  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent data-testid="higher-payby-dialog" className="bg-zinc-950 border-zinc-800 sm:rounded-2xl">
        <DialogHeader>
          <DialogTitle className="font-display text-2xl">EMS Pay-by Date</DialogTitle>
          <DialogDescription>One date for all Higher EMS. Joiners who still owe get "Due soon" in the last 24 hours, then "Past due".</DialogDescription>
        </DialogHeader>
        <form onSubmit={(e) => { e.preventDefault(); save(fromKSTInput(value)); }} className="space-y-4">
          <div className="space-y-1.5">
            <Label>Pay by (KST)</Label>
            <Input type="datetime-local" required data-testid="higher-payby-input" value={value} onChange={(e) => setValue(e.target.value)} className="bg-zinc-900 [color-scheme:dark]" />
            {current && <div data-testid="higher-payby-current" className="text-xs text-zinc-500">Currently {fmtKST(current)}</div>}
          </div>
          <div className="grid grid-cols-2 gap-2">
            <Button type="button" variant="outline" disabled={busy || !current} data-testid="higher-payby-clear" onClick={() => save("")} className="rounded-xl border-zinc-700 bg-transparent">Clear date</Button>
            <Button type="submit" disabled={busy || !value} data-testid="higher-payby-save" className="rounded-xl bg-white text-zinc-950 hover:bg-zinc-200 font-semibold">
              {busy && <Loader2 className="h-4 w-4 mr-2 animate-spin" />}Save
            </Button>
          </div>
        </form>
      </DialogContent>
    </Dialog>
  );
}
